import React, { useCallback, useState } from 'react';
import { ActivityIndicator, Image } from 'react-native';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
import styleUtils from 'src/utils/styles';
import RowCenter from '../layout/RowCenter';
import useRemoteImageDimens from './useRemoteImageDimens';
const FitImage = ({ style, spacing = 0, source, imageStyle, ...rowCenterProps }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    const [containerWidth, setContainerWidth] = useState(-1);
    const [imageDimens] = useRemoteImageDimens(source.uri);
    const handleLayout = useCallback((ev) => {
        const width = ev.nativeEvent.layout.width;
        setContainerWidth(width);
    }, []);
    const containerMeasured = containerWidth > -1;
    const imageMeasured = !!imageDimens;
    const showImage = containerMeasured && imageMeasured;
    const imageHeight = imageMeasured && showImage
        ? Math.round(containerWidth * (imageDimens.height / imageDimens.width))
        : 100;
    return !showImage ? (React.createElement(RowCenter, { onLayout: handleLayout, style: [style, styles.loadingContainer], ...rowCenterProps },
        React.createElement(ActivityIndicator, { color: theme.palette.primary.main, size: "small" }))) : (React.createElement(RowCenter, { style: [
            style,
            {
                width: containerWidth,
                height: imageHeight + spacing,
                maxWidth: containerWidth,
                maxHeight: imageHeight + spacing,
            },
            styles.container,
            styleUtils.ovfHidden,
        ], ...rowCenterProps },
        React.createElement(Image, { source: source, style: [
                imageStyle,
                {
                    maxWidth: containerWidth,
                    maxHeight: imageHeight,
                    width: containerWidth,
                    height: imageHeight,
                },
            ] })));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        borderRadius: theme.borderRadius.standard.lg,
    },
    loadingContainer: {
        width: '100%',
        height: 100,
        borderRadius: theme.borderRadius.standard.lg,
    },
}));
export default FitImage;
